import type { Investigation } from '../../../api/files.types';

interface TableRow {
  sid: string;
  type: string;
  eventsTotal: string;
  hostname: string;
}

export function transformDataForTable(data: Investigation): TableRow[] {
  const tableRows: TableRow[] = [];

  Object.entries(data.data.extractionDetails).forEach(([systemId, assetData]) => {
    const hostIP = assetData.assetHostName;

    Object.entries(assetData).forEach(([key, value]) => {
      if (key === 'assetHostName') return;

      if (typeof value !== 'object' || value === null) return;

      const allRuns = Object.values(value);

      const totalCount = allRuns.reduce((sum, run) => {
        return sum + (run.rowCount ?? 0);
      }, 0);

      tableRows.push({
        sid: systemId,
        type: key,
        eventsTotal: totalCount.toString(),
        hostname: hostIP,
      });
    });
  });

  return tableRows;
}
